import React from "react";
import Sidebar from "../Sidebar/Sidebar";
import { Box, Stack, Modal, Autocomplete, MenuItem } from "@mui/material";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import LocalstorageHelper from "../../LocalStorageHelper/LocalstorageHelper";
import { Redirect } from "react-router-dom";
import Task from "@mui/icons-material/Task";
import ReportNavigation from "../../Components/ReportNavigation/ReportNavigation";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DataGrid } from "@mui/x-data-grid";
import AddCircleOutline from "@mui/icons-material/AddCircleOutline";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import PrintIcon from "@mui/icons-material/Print";
import ReportLoadingDialog from "../../Components/ReportLoadingDialog";
const HsnReport = () => {
  //GET THE TOKEN FROM HELPER CLASS

  const userToken = LocalstorageHelper.GetUserToken();

  const redirectToLoginPage = () => {
    if (!userToken) {
      return <Redirect exact to="/sparepartsLogin" />;
    }
  };

  //TIMEOUT WHEN JWT EXPIRES
  setTimeout(() => {
    window.location.reload(false);
  }, 1800000);

  // TEXT FIELD VALUE STATES
  const date = new Date();

  const [radioInput, setRadioInput] = useState(0);
  const handleRadio = (e) => {
    setRadioInput(e.target.value);
  };
  const [todate, settodate] = useState(date);
  const [fromdate, setfromdate] = useState(null);
  const [pdfStream, setPdfStream] = useState(null);
  const [loading, setLoading] = useState(false);
  const [genrating, setgenrating] = useState(false);
  const [reportText, setReportText] = useState({
    title: "",
    subtitle: "",
  });
  //fetch state data
  async function getfromdatedata() {
    try {
      const response = await fetch("/reports/fromdate", {
        method: "GET",
        headers: { sptoken: userToken },
      });
      const jsonData = await response.json();
      setfromdate(jsonData.fromdate);
    } catch (err) {
      console.error(err.message);
    }
  }
  useEffect(() => {
    getfromdatedata();
  }, []);

  const handleReport = async (e) => {
    e.preventDefault();
    setLoading(true);
    setReportText({
      title:
        parseInt(radioInput) === 1
          ? "Generating HSN Register For Sale"
          : "Generating HSN Register For Purchase",
      subtitle: "Preparing PDF report. Please wait…",
    });

    setgenrating(true);
    if (fromdate === null) {
      setLoading(false);
      return toast.error("Please Enter Date");
    }
    try {
      const fromDateStr = fromdate;
      const toDateStr = todate.toISOString();
      const res = await fetch(
        `reports/spare/hsnreport/${radioInput}/${fromDateStr}/${toDateStr}`,
        {
          method: "GET",
          headers: {
            sptoken: userToken,
          },
        }
      );
      const data = await res.blob();
      const pdfUrl = URL.createObjectURL(data);
      setPdfStream(pdfUrl);
      setLoading(false);
      setgenrating(false);
    } catch (error) {
      setLoading(false);
      setgenrating(false);
      console.log(error.message);
    }
  };
  const handleDownload = async (option, reportName) => {
    if (fromdate === null) {
      setLoading(false);
      return toast.error("Please Enter Date");
    }
    try {
      const fromDateStr = fromdate;
      const toDateStr = todate.toISOString();
      const res = await fetch(
        `/reports/spare/hsnreport/download/${radioInput}/${option}/${fromDateStr}/${toDateStr}`,
        {
          method: "GET",
          headers: {
            sptoken: userToken,
          },
        }
      );
      if (!res.ok) {
        throw new Error(`Failed to fetch the PDF. Status: ${res.status}`);
      }
      if (parseInt(option) === 1) {
        const blob = await res.blob(); // Convert response to a Blob
        const filename = `${
          parseInt(radioInput) === 0 ? "hsnPurchase" : "hsnSale"
        }_${toDateStr}.pdf`; // Set the desired file name for the download
        // Create a download link
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename;

        // Programmatically click the link to initiate download
        link.click();

        // Clean up resources
        URL.revokeObjectURL(link.href);
      } else {
        const blob = await res.blob(); // Convert response to a Blob
        const filename = `${
          parseInt(radioInput) === 0 ? "hsnPurchase" : "hsnSale"
        }_${toDateStr}.xlsx`; // Set the desired file name for the download
        // Create a download link
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename;

        // Programmatically click the link to initiate download
        link.click();

        // Clean up resources
        URL.revokeObjectURL(link.href);
      }
    } catch (error) {
      console.log(error.message);
    }
    console.log(`Downloading ${option} report: ${reportName}`);
  };

  //print excel
  const printexcel = async (e) => {
    e.preventDefault();
    setReportText({
      title:
        parseInt(radioInput) === 1
          ? "Generating HSN Register For Sale"
          : "Generating HSN Register For Purchase",
      subtitle: "Preparing Excel report. Please wait…",
    });

    setgenrating(true);
    if (fromdate === null) {
      setLoading(false);
      return toast.error("Please Enter Date");
    }
    try {
      const fromDateStr = fromdate;
      const toDateStr = todate.toISOString();
      const data = await fetch(
        `/reports/hsnreport/excel//${radioInput}/${fromDateStr}/${toDateStr}`,
        {
          method: "GET",
          headers: {
            sptoken: userToken,
          },
        }
      );

      const blob = await data.blob();

      // Create a download link
      const downloadLink = document.createElement("a");
      downloadLink.href = window.URL.createObjectURL(blob);
      parseInt(radioInput) === 0
        ? (downloadLink.download = "HSN_PURCHASE_REPORT")
        : (downloadLink.download = "HSN_SALE_REPORT");

      // Append the link to the body
      document.body.appendChild(downloadLink);

      // Trigger the click event to start the download
      downloadLink.click();

      // Remove the link from the body
      document.body.removeChild(downloadLink);
      setgenrating(false);
    } catch (error) {
      setgenrating(false);
      console.log(error.message);
    }
  };
  const printsummaryexcel = async (e) => {
    e.preventDefault();
    setReportText({
      title: "Generating HSN Register Summary For Sale",
      subtitle: "Preparing Excel report. Please wait…",
    });

    setgenrating(true);
    if (fromdate === null) {
      setLoading(false);
      return toast.error("Please Enter Date");
    }
    try {
      const body = { radioInput, fromdate, todate };
      const data = await fetch(`/reports/hsnreport/summary/excel`, {
        method: "POST",
        headers: {
          sptoken: userToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      const blob = await data.blob();

      // Create a download link
      const downloadLink = document.createElement("a");
      downloadLink.href = window.URL.createObjectURL(blob);
      downloadLink.download = "HSN_SALE_SUMMARY_REPORT";

      // Append the link to the body
      document.body.appendChild(downloadLink);

      // Trigger the click event to start the download
      downloadLink.click();

      // Remove the link from the body
      document.body.removeChild(downloadLink);
      setgenrating(false);
    } catch (error) {
      console.log(error.message);
    }
  };
  //is_ServiceCreditNoteHsn
  const printis_ServiceCreditNoteHsn = async (e) => {
    e.preventDefault();
    setReportText({
      title: "Generating IS Service Credit Note HSN Register",
      subtitle: "Preparing Excel report. Please wait…",
    });

    setgenrating(true);
    if (fromdate === null) {
      setLoading(false);
      return toast.error("Please Enter Date");
    }
    try {
      const body = { fromdate, todate };
      const data = await fetch("/reports/hsn/isserv/cn/excel", {
        method: "POST",
        headers: {
          sptoken: userToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      const blob = await data.blob();

      // Create a download link
      const downloadLink = document.createElement("a");
      downloadLink.href = window.URL.createObjectURL(blob);
      downloadLink.download = "isService_CreditNote_HSN";

      // Append the link to the body
      document.body.appendChild(downloadLink);

      // Trigger the click event to start the download
      downloadLink.click();

      // Remove the link from the body
      document.body.removeChild(downloadLink);
      setgenrating(false);
    } catch (error) {
      setgenrating(false);
      console.log(error.message);
    }
  };
  //HSN SALE RTN EXCEL
  const printSaleRtnhsnExcel = async (e) => {
    e.preventDefault();
    setReportText({
      title: "Generating Sale Return HSN Register",
      subtitle: "Preparing Excel report. Please wait…",
    });

    setgenrating(true);
    if (fromdate === null) {
      setLoading(false);
      return toast.error("Please Enter Date");
    }
    try {
      const body = { fromdate, todate };
      const data = await fetch(`/reports/salertn/hsnreport/excel`, {
        method: "POST",
        headers: {
          sptoken: userToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      const blob = await data.blob();

      // Create a download link
      const downloadLink = document.createElement("a");
      downloadLink.href = window.URL.createObjectURL(blob);
      downloadLink.download = "HSN_SALE_RTN_REPORT";

      // Append the link to the body
      document.body.appendChild(downloadLink);

      // Trigger the click event to start the download
      downloadLink.click();
      setgenrating(false);
      // Remove the link from the body
      document.body.removeChild(downloadLink);
    } catch (error) {
      setgenrating(false);
      console.log(error.message);
    }
  };
  return (
    <>
      <ReportLoadingDialog
        open={genrating}
        title={reportText.title}
        subtitle={reportText.subtitle}
      />
      <Sidebar
        Title={"HSN REPORT"}
        expandedPanel={"panel3"}
        children={
          <Box
            component="form"
            sx={{
              width: "100%",
            }}
            //onSubmit={handleSubmit}
            autoComplete="off"
          >
            <Box
              sx={{
                marginTop: "4rem",
                display: "flex",
                flexWrap: "wrap",
                columnGap: "20px",
                rowGap: "20px",
                justifyContent: "center",
              }}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="From Date"
                  inputFormat="DD/MM/YYYY"
                  value={fromdate}
                  onChange={(newValue) => {
                    setfromdate(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      required
                      {...params}
                      sx={{
                        width: "20%",
                      }}
                      size="small"
                    />
                  )}
                />
              </LocalizationProvider>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="To Date"
                  inputFormat="DD/MM/YYYY"
                  value={todate}
                  onChange={(newValue) => {
                    settodate(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      required
                      {...params}
                      sx={{
                        width: "20%",
                      }}
                      size="small"
                    />
                  )}
                />
              </LocalizationProvider>
              <Button
                onClick={printexcel}
                size="small"
                variant="contained"
                color="success"
                endIcon={<PrintIcon />}
              >
                Excel
              </Button>
              <Button
                onClick={printsummaryexcel}
                size="small"
                variant="contained"
                color="success"
                endIcon={<PrintIcon />}
              >
                HSN_SALE_SUM_Excel
              </Button>
              <Button
                onClick={printis_ServiceCreditNoteHsn}
                size="small"
                variant="contained"
                color="success"
                endIcon={<PrintIcon />}
              >
                is_Service Credit Note Hsn
              </Button>
              <Button
                onClick={printSaleRtnhsnExcel}
                size="small"
                variant="contained"
                color="success"
                endIcon={<PrintIcon />}
              >
                HSN_SALE_RTN_Excel
              </Button>
            </Box>
            <Box
              sx={{
                marginTop: "4rem",
                display: "flex",
                flexWrap: "wrap",
                columnGap: "20px",
                justifyContent: "center",
              }}
            >
              <FormControl>
                <FormLabel id="demo-controlled-radio-buttons-group">
                  Options
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="controlled-radio-buttons-group"
                  value={radioInput}
                  onChange={handleRadio}
                >
                  <FormControlLabel
                    value={0}
                    control={<Radio />}
                    label="Purchase"
                  />
                  <FormControlLabel
                    value={1}
                    control={<Radio />}
                    label="Sale"
                  />
                </RadioGroup>
              </FormControl>
              <Button
                type="submit"
                onClick={handleReport}
                disabled={loading === true}
                variant="contained"
                component="label"
                size="large"
                sx={{
                  height: "50px",
                  width: "200px",
                  boxShadow: "2px 2px 6px  #404142",
                }}
                endIcon={<Task />}
              >
                {loading ? "Fetching Data..." : " Show Report"}
              </Button>
            </Box>
            {pdfStream && (
              <ReportNavigation
                onDownload={handleDownload}
                reportName={"HSN REPORT"}
              />
            )}
            <Box sx={{ backgroundColor: "white" }}>
              {pdfStream && (
                <iframe
                  src={pdfStream}
                  width="100%"
                  height="680px"
                  title="report"
                ></iframe>
              )}
            </Box>
          </Box>
        }
      />
      {/* <FooterElement /> onDownload={handleDownload} reportName={"pickerperformance"}*/}
      {redirectToLoginPage()}
    </>
  );
};

export default HsnReport;
